import { html, SYSBaseElement, SYSTableDefIds } from "../../../../.."
import { TableGet } from "../../../tableapi"

export class SYSHeaderMenuFilter extends SYSBaseElement {
  defId: SYSTableDefIds
  instance: string
  columnKey: string
  async getUI() {
    let tableDef = TableGet(this.defId)
    let column = tableDef.def.columns[this.columnKey]
    let hasRangeFilter = column.filter.rangeFilter !== undefined
    let hasColumnFilter = column.filter.columnFilter !== undefined
    if (!hasRangeFilter && !hasColumnFilter) {
      return undefined
    }
    let rangeFilter
    if (hasRangeFilter) {
      rangeFilter = html`<ovl-headermenurangefilter
        .instance=${this.instance}
      ></ovl-headermenurangefilter>`
    }
    let columnFilter
    if (hasColumnFilter) {
      columnFilter = html`<ovl-headermenucolumnfilter
        .defId=${this.defId}
        .columnKey=${this.columnKey}
      ></ovl-headermenucolumnfilter>`
    }

    return html` <div class="ovl-headermenufilter">
      <span
        class="fd-list__icon sap-icon--filter ${hasRangeFilter &&
        hasColumnFilter
          ? "ovl-adjust"
          : ""}"
      ></span>
      <div>${columnFilter}${rangeFilter}</div>
    </div>`
  }
}
